// extracted by mini-css-extract-plugin
export var slideContent = "styles-module--slideContent--QxPHT";
export var slide = "styles-module--slide--3-HM4";
export var slider = "styles-module--slider--3j-Va";
export var sliderBasis = "styles-module--sliderBasis--3LUsC";